import { Button, Container, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import trackAmplitude from 'services/analytics';
import { WEB_UNEXPECTED_ERROR } from 'utils/AmplitudeTrackEvents';
import { useTranslation } from 'react-i18next';
import { DEBUG } from 'utils/constants';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (!DEBUG) {
      trackAmplitude(WEB_UNEXPECTED_ERROR, parseError(error));
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorComponent />;
    }

    return this.props.children;
  }
}

const ErrorComponent = () => {
  const { t } = useTranslation();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  };
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Container maxWidth="xs" sx={{ height: '100vh', py: 20 }}>
      <Stack
        gap={1}
        alignItems="center"
        justifyContent="space-between"
        height="100%"
      >
        <Stack flex={1} justifyContent="center">
          <Typography fontSize={24} fontWeight={700} textAlign="center">
            {t('errorBoundary.title')}
          </Typography>
        </Stack>
        <Stack width="100%" gap={1} flexDirection={'row'}>
          <Button
            sx={{ flex: 1 }}
            variant="contained"
            size="large"
            onClick={handleGoBack}
          >
            {t('errorBoundary.go_back')}
          </Button>
          <Button
            sx={{ flex: 1 }}
            variant="contained"
            size="large"
            onClick={handleReload}
          >
            {t('errorBoundary.reload')}
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};

function parseError(error) {
  if (error instanceof Error) {
    return {
      errorName: error?.name,
      errorMessage: error?.message,
      errorStack: error?.stack,
    };
  }
  return {
    error: JSON.stringify(error) || 'Unknown error',
  };
}
